export const sponsorRegistration = [
  {
    itemNo: "1",
    item: "The party of the first Part agrees to cultivate and produce and deliver to the party of second Part and the party of Second Part agrees to buy from the party of the First Part the agreed items of the agricultural produce/items as per the quality, quantity and price of the items more particularly mentioned in the Schedule Annexed hereto.",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "2",
    item: `
    The agricultural produce the particulars of which are mentioned in the Schedule annexed hereto
    shall be supplied by the party of the first Part to the party of the second Part within the period of
    <input type="text" name="periodOfMonths" placeholder="Enter Period of Months" />
    months/years from the date hereof.
    <br /><br />
    <div style="text-align: center; font-weight: bold;">OR</div>
    <br />
    It is expressly agreed between the parties hereto that this Agreement is for agricultural produce particulars of which are described in the Schedule annexed hereto
    and for a period of
    <input type="text" name="periodOfMonths" placeholder="Enter Period of Months" />
    month/years and at the expiration of said period, this agreement shall automatically come to an end.
  `,
    isBlankExist: true,
    blank: [
      { blankVal: "periodOfMonths", blankType: "text", blankName: "Period of Months" },
      { blankVal: "periodOfMonths", blankType: "text", blankName: "Period of Months" }
    ],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  // {
  //   itemNo: "2",
  //   item:"The agricultural produce the particulars of which are mentioned in the Schedule annexed hereto shall be supplied by the party of the first Part to the party of the second Part within the period of ...... months/years from the date hereof, OR it is expressly agreed between the parties hereto that this Agreement is for agricultural produce particulars of which are described in the Schedule annexed hereto and for a period of ...... month/years and at the expiration of said period, this agreement shall automatically come to an end.",
  //   isBlankExist:true,
  //   blank:[
  //     {blankVal:"periodOfMonths", blankType:"text", blankName:"Period of Months"},
  //     {blankVal:"periodOfMonths", blankType:"text", blankName:"Period of Months"}
  //   ],
  //   subItem: [],
  //   isTableExist:false,
  //   tableItems:[],
  // },
  {
    itemNo: "3",
    item: "The party of the first Part agrees co cultivate and produce and supply quantity mentioned in the Schedule annexed hereto the party of the Second Part.",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "4",
    item: `
    The party of the first Part agrees to supply the Quantity contracted according to the quality specification stipulated in the Schedule annexed hereto. 
    If the agricultural produce is not as per the agreed quality standards, the party of the second Part shall be entitled to refuse to take the delivery of the 
    agricultural produce concerned. It is further agreed by and between the parties that-
    <br />
    <b>Sub-items: </b>
    <br />
    a) the party of the first Part shall be free to sell the produce to the party of the second Part at mutually re-negotiated price; OR 
        the party of the first Part shall be free to sell the produce in the open market (to bulk Buyer viz. exporter/processor/ manufacturer etc.) and 
        if he gets less price than the price contracted, he shall pay proportionately less amount to the party of the second Part for his investment; OR 
        the party of the first Part shall be free to sell the produce in the market yard and if the price obtained by him is less than the price contracted, 
        then he shall return proportionately less amount to the party of second Part for his investment
      <br />
      b) In case the party of the second Part refuses or fails to take the delivery of the contracted produce for his own reasons then the party 
        of the first Part shall be free to sell the produce in open market and if price received is lower than the contracted price, the difference shall be 
        borne by the party of the second Part and the party of the Second Part shall pay such difference to the party of the first Part within a period of 
        fifteen days from the date by which the said difference is asserted.
    `,
    isBlankExist: false,
    blank: [],
    subItem: [
      // {
      //   subitemNo:"1",
      //   subItemSno:"",
      //   subItemVal:"",
      // },
      // {
      //   subitemNo:"2",
      //   subItemSno:"",
      //   subItemVal:"",
      // },
    ],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "5",
    item: `The party of the first Part agrees to adopt instructions or practices in respect of the land preparation, nursery, fertilization, pest management,
     irrigation, harvesting and any other, as may be suggested by the party of the second Part, from time to time, and cultivate the items as per the 
     specifications mentioned in the Schedule annexed hereto`,
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "6",
    dateOFAgreement: "",
    deliveryPoint: "",
    costOFDelivery: "",
    item: `
    It is expressly agreed by and between the parties hereto that buying shall be as per the following terms and buying slips shall be issued immediately 
    after the purchase - @table@ It is further agreed that it shall be the responsibility of the party of the Second Part to take into possession the contracted
     produce at the delivery point after it is offered for delivery and if he fails to take delivery within 
     period then the party of the first Part shall 
     be free to sell the agriculture produce contracted as under.-Either in the open market (bulk buyer viz. exporter or processor or manufacturer, etc.) and 
     if he gets a price less than the price contracted, he shall pay proportionately less amount to the party of the second Part for his investment; ORIn 
     the market yard, and if the price obtained is less than the contracted price, then he shall return proportionately less amount to the party of the second 
     Part for his investment.It is further agreed that the quality maintenance during transit shall be the responsibility of the party of the second Part and the 
     party of the first Part shall not be responsible or liable for the same.

     `,
    isBlankExist: true,
    blank: [
      // { blankVal: "periodOfDelivery", blankType: "text", blankName: "Period of Delivery" }
    ],
    subItem: [],
    isTableExist: true,
    tableItems: [
      { tableVal: "dateOFAgreement", tableType: "date", tableHeading: "Date of Agreement" },
      { tableVal: "deliveryPoint", tableType: "text", tableHeading: "Delivery Point" },
      { tableVal: "costOFDelivery", tableType: "text", tableHeading: "Cost of Delivery" },
      { tableVal: "periodOfDelivery", tableType: "text", tableHeading: "Period of Delivery" }
    ],
  },
  {
    itemNo: "7",
    item: "The party of the second Part shall pay to the party of the first Part, the price or rate mentioned in the Schedule annexed hereto when his crop has been harvested and delivered to the party of the second Part after deducting all outstanding advances given to the party of the first Part by the party of Second Part. The following table shall be followed for the payment:",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: true,
    tableItems: [
      { tableVal: "dateOfScheduled", tableType: "date", tableHeading: "Date of Schedule" },
      { tableVal: "modeOfPayment", tableType: "text", tableHeading: "Mode of Payment" },
      { tableVal: "placeOfPayment", tableType: "text", tableHeading: "Place of Payment" }
    ],

  },
  {
    itemNo: "8",
    item: `The parties hereto shall insure the contracted produce mentioned in the Schedule annexed hereto, for the period of
     <input type="text" name="contractedProduce" placeholder="Enter Period of Months" /> 
     against the risk of losses due to Act of God, destruction of specified assets, loan default and production and income loss and all other acts or events beyond the control of the parties, such as very low production caused by the serious outbreak of a disease, epidemic or by abnormal whether condition, floods, droughts, hailstorm, cyclones, earthquakes, fire or other catastrophes, war, acts of government, action existing on or after the effective date of this agreement which prevent totally or partially the fulfillment of the obligation on the part of the agriculturists. Upon request, the Party of the First Part invoking such acts shall provide to the Party of the Second Part the confirmation of the existence of facts. Such evidence shall consist of a statement or certificate of the appropriate Government Department. If such a statement or certificate cannot reasonably be obtained, the party of the First Part claiming such acts may, in lieu thereof, make a notarial statement describing in details the facts claimed and the reasons why such a certificate or statement confirming the existing of such facts has not been obtained. Alternatively but subject to the mutual agreement between the parties, the party of the First Part may fill his quota of the produce through other sources in which case the loss suffered by him on account of price difference shall be shared equally by the parties after taking into account the amount recovered from the insurance company. The insurance premium shall be shared equally be both the parties.`,
    isBlankExist: true,
    blank: [
      { blankVal: "contractedProduce", blankType: "text", blankName: "Period" },
    ],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "9",
    item: "The party of second Part hereby agrees to provide the following services to the party of the First Part during the period of cultivation and post harvest management.The particulars of such services are as follows:- 1.2.3.4.",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "10",
    item: "The Party of the second Part shall not thrust the labour on the party of the First Part",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "11",
    item: "The Party of the second Part agrees to have regular interactions with the agriculturist forum set up or named by the Party of the First Part during the period of contract, by himself or through his authorised representative.",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "12",
    item: "The Party of the second Part or it's representative shall have at their costs the right to enter in the premises or the fields of the Party of the First Part to monitor farming practices adopted and the quality of the produce from time to time.",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "13",
    item: `The Party of the second Part confirms that he has registered himself with the 
     <input type="text" name="registrationAuthority" placeholder="Name of Authority" /> 
     on 
     <input type="text" name="registrationDate" placeholder="Registration Date" />  
     and shall pay thefees in accordance with the rules prevailing in his regards to
     <input type="text" name="regardingAuthority" placeholder="Jurisdiction Authority" /> 
      which has jurisdiction to register the contract farming sponsor for the agriculture produce which is cultivated on the land described
       <input type="text" name="landDescriptionReference" placeholder="Reference(Schedule A)" />  
       or the Party of the second part has registered himself on 
        <input type="text" name="singlePointRegistrationDate" placeholder="Single Point Reg. Date" />  
        with a single point registering authority, namely 
        <input type="text" name="singlePointAuthorityName" placeholder="Single Point Authority Name" /> 
        prescribed by the State Government in this regard. The fees levied by the respective
        <input type="text" name="feeAuthority" placeholder="Respective Authority for Fees" />  
         (authority) shall be borne by the party of second Part exclusively and shall not be deducted in any manner, whatsoever, from the amount paid to the party of the First Part.)`,
    isBlankExist: true,
    "blank": [
      {
        blankVal: "registrationAuthority",
        blankType: "text",
        blankName: "Name of Authority"
      },
      {
        blankVal: "registrationDate",
        blankType: "date",
        blankName: "Date of Registration"
      },
      {
        blankVal: "regardingAuthority",
        blankType: "text",
        blankName: "Jurisdiction Authority"
      },
      {
        blankVal: "landDescriptionReference",
        blankType: "text",
        blankName: "Land Description Reference (e.g.Schedule A)"
      },
      {
        blankVal: "singlePointRegistrationDate",
        blankType: "date",
        blankName: "Single Point Registration Date"
      },
      {
        blankVal: "singlePointAuthorityName",
        blankType: "text",
        blankName: "Name of Single Point Authority"
      },
      {
        blankVal: "feeAuthority",
        blankType: "text",
        blankName: "Respective Authority for Fees"
      }
    ],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "14",
    item: "The Party of the second Part shall have no rights whatsoever as to the title, ownership, possession of the land / property of the party of the first Part nor shall it in any way alienate the property of the party of the first Part particularly nor mortgage, lease, sub-lease or transfer the land, property of the First Party in any way to any other person or institution during the continuance of this agreement.",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "15",
    item: `The Party of the second Part shall submit original copy of this agreement signed by both the parties within a period of fifteen days from the date of execution thereof to 
    <input type="text" name="registeringAuthorityName" placeholder="Reg. Autho. Name" />  
    (Registering authority prescribed for the purpose).`,
    isBlankExist: true,
    blank: [
      {
        blankVal: "registeringAuthorityName",
        blankType: "text",
        blankName: "Registering authority prescribed for the purpose"
      }
    ],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "16",
    item: "Dissolution, termination or cancellation of the Contract Farming Agreement shall be with the consent of both the parties. Such dissolution or termination or cancellation shall be communicated to the registering authority within a period of fifteen days from its occurrence.)",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "17",
    item: "All disputes and differences whatsoever arising between the parties hereto or persons claiming under them touching this agreement or any matter or thing contained or the construction thereof or as to the rights and liabilities of either of the parties under this agreement or as to any claim monetary or otherwise of one party against the other shall be referred to Taluka/District Officers concerned with regulation of Agriculture Marketing (designated as or assigned the functions of the Dispute Settlement Authority).",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "18",
    item: `In case of change of address of any party to this agreement the same shall be intimated to the other party and also to the 
    <input type="text" name="addressChangeAuthority" placeholder="Address Change Autho." />   
    (the registering authority prescribed for this purpose).`,
    isBlankExist: true,
    blank: [
      {
        blankVal: "addressChangeAuthority",
        blankType: "text",
        blankName: "The registering authority prescribed for this purpose"
      }
    ],
    subItem: [],
    isTableExist: false,
    tableItems: [],
  },
  {
    itemNo: "19",
    item: "Each party hereto shall act in good faith and honestly with the other in the performance of their responsibilities under this agreement and nothing will be done which may jeopardize their interest SCHEDULE above referred to Grade Specification, Quantity and Price Chart",
    isBlankExist: false,
    blank: [],
    subItem: [],
    isTableExist: true,
    tableItems: [
      { tableVal: "grade", tableType: "text", tableHeading: "Grade 1 or A" },
      { tableVal: "specifications", tableType: "text", tableHeading: "Specifications" },
      { tableVal: "quantity", tableType: "text", tableHeading: "Quantity" },
      { tableVal: "price", tableType: "text", tableHeading: "Price/Rate" },
    ]
  },
];



export const backUpTableCF = [
  {
    "fieldNo": "01.",
    "fieldVal": "નામ (Name)",
    "response": [
      { "responseType": "input", "fieldName": "sponsorName", "responseVal": "sponsorName", "responseName": "Enter Name" }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldVal": "કંપની/એનજીઓ/સહકારી સંસ્થા/સરકારી સંસ્થાના કિસ્સામાં નિર્દેશકો/ભાગીદારોના નામ (In case of firm/NGO/Co-op society/Govt Organization names of directors/partners)",
    "response": [
      { "responseType": "input", "fieldName": "namesOfDirector", "responseVal": "namesOfDirector", "responseName": "Enter Director Name" }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldVal": "કંપની/એનજીઓ/સહકારી સંસ્થા/સરકારી સંસ્થાના કિસ્સામાં નિર્દેશકો/ભાગીદારોના સરનામા (In case of firm/NGO/Co-op society/Govt Organization address of directors/partners)",
    "response": [
      { "responseType": "input", "fieldName": "addressOfDirector", "responseVal": "addressOfDirector", "responseName": "Enter Director Address" }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldVal": "ફોન નંબર (Phone Number)",
    "response": [
      { "responseType": "input", "fieldName": "phoneNumber", "responseVal": "phoneNumber", "responseName": "Enter Phone Number" }
    ]
  },
  {
    "fieldNo": "05.",
    "fieldVal": "તારીખથી (From Date) તારીખ સુધી (To Date)",
    "response": [
      { "responseType": "date", "fieldName": "fromDate", "responseVal": "fromDate", "responseName": "Select From Date" },
      { "responseType": "date", "fieldName": "toDate", "responseVal": "toDate", "responseName": "Select To Date" }
    ]
  },
  {
    "fieldNo": "06.",
    "fieldVal": "જિલ્લો અને બજાર સમિતિ પસંદ કરો (Select District and APMC)",
    "response": [
      { "responseType": "select", "fieldName": "district", "responseVal": "district", "responseName": "Select District" },
      { "responseType": "select", "fieldName": "apmc", "responseVal": "apmc", "responseName": "Select APMC" }
    ]
  },
  {
    "fieldNo": "07.",
    "fieldVal": "શોલ્વન્સી પ્રમાણપત્ર (Solvency Certificate)",
    "response": [
      { "responseType": "file", "fieldName": "solvencyCertificate", "responseVal": "solvencyCertificate", "responseName": "Choose File / Upload Document" }
    ]
  },
  {
    "fieldNo": "08.",
    "fieldVal": "બેંક ગેરંટી (Bank Guarantee)",
    "response": [
      { "responseType": "file", "fieldName": "bankGuarantee", "responseVal": "bankGuarantee", "responseName": "Choose File / Upload Document" }
    ]
  },
  {
    "fieldNo": "09.",
    "fieldVal": "કંપની/એનજીઓ/સહકારી સંસ્થા/સરકારી સંસ્થાના કિસ્સામાં નોંધણી દસ્તાવેજો (In case of firm/NGO/Co-op society/Govt Organization details of registration documents)",
    "response": [
      { "responseType": "file", "fieldName": "registrationDocs", "responseVal": "registrationDocs", "responseName": "Choose File / Upload Document" }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldVal": "આ કરાર હેઠળ આવતી APMC ની વિગતો (Details of APMC coming under this contract)",
    "response": [
      { "responseType": "file", "fieldName": "apmcDetails", "responseVal": "apmcDetails", "responseName": "Choose File / Upload Document" }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldVal": "ઉત્પાદન, પ્રોસેસિંગ, નિકાસ-આયાત લાઇસન્સનો પુરાવો (Proof of manufacturing, processing, export-import license)",
    "response": [
      { "responseType": "file", "fieldName": "proofLicense", "responseVal": "proofLicense", "responseName": "Choose File / Upload Document" }
    ]
  }
];

export const DistrictOptionsAPMC = {
  isMulti: true,
  options: [
    { value: "ahmedabad", label: "Ahmedabad" },
    { value: "amreli", label: "Amreli" },
    { value: "anand", label: "Anand" },
    { value: "aravalli", label: "Aravalli" },
    { value: "banaskantha", label: "Banaskantha" },
    { value: "bharuch", label: "Bharuch" },
    { value: "bhavnagar", label: "Bhavnagar" },
    { value: "botad", label: "Botad" },
    { value: "chhota udaipur", label: "Chhota Udaipur" },
    { value: "dahod", label: "Dahod" },
    { value: "dang", label: "Dang" },
    { value: "devbhoomi dwarka", label: "Devbhoomi Dwarka" },
    { value: "gandhinagar", label: "Gandhinagar" },
    { value: "gir somnath", label: "Gir Somnath" },
    { value: "jamnagar", label: "Jamnagar" },
    { value: "junagadh", label: "Junagadh" },
    { value: "kheda", label: "Kheda" },
    { value: "kutch", label: "Kutch" },
    { value: "mahisagar", label: "Mahisagar" },
    { value: "mehsana", label: "Mehsana" },
    { value: "morbi", label: "Morbi" },
    { value: "narmada", label: "Narmada" },
    { value: "navsari", label: "Navsari" },
    { value: "panchmahal", label: "Panchmahal" },
    { value: "patan", label: "Patan" },
    { value: "porbandar", label: "Porbandar" },
    { value: "rajkot", label: "Rajkot" },
    { value: "sabarkantha", label: "Sabarkantha" },
    { value: "surat", label: "Surat" },
    { value: "surendranagar", label: "Surendranagar" },
    { value: "tapi", label: "Tapi" },
    { value: "vadodara", label: "Vadodara" },
    { value: "valsad", label: "Valsad" },
  ],
};
export const APMCsByDistrict = {
  ahmedabad: ["Ahmedabad City", "Dhandhuka", "Sanand"],
  amreli: ["Amreli Main", "Savarkundla", "Lathi"],
  anand: ["Anand City", "Borsad", "Umreth"],
  aravalli: ["Modasa", "Bayad", "Dhansura"],
  banaskantha: ["Deesa", "Palanpur", "Tharad"],
  bharuch: ["Bharuch Main", "Ankleshwar", "Jambusar"],
  bhavnagar: ["Bhavnagar City", "Mahuva", "Gariadhar"],
  botad: ["Botad", "Barwala"],
  chhotaUdaipur: ["Chhota Udaipur", "Nasvadi"],
  dahod: ["Dahod Main", "Limkheda"],
  dang: ["Ahwa"],
  devbhoomiDwarka: ["Khambhalia", "Dwarka"],
  gandhinagar: ["Gandhinagar Main", "Kalol"],
  girSomnath: ["Veraval", "Kodinar"],
  jamnagar: ["Jamnagar", "Dhrol", "Kalavad"],
  junagadh: ["Junagadh", "Manavadar"],
  kheda: ["Nadiad", "Kapadvanj"],
  kutch: ["Bhuj", "Gandhidham"],
  mahisagar: ["Lunawada"],
  mehsana: ["Mehsana", "Kadi"],
  morbi: ["Morbi", "Wankaner"],
  narmada: ["Rajpipla"],
  navsari: ["Navsari", "Gandevi"],
  panchmahal: ["Godhra", "Halol"],
  patan: ["Patan", "Sidhpur"],
  porbandar: ["Porbandar", "Kutiyana"],
  rajkot: ["Rajkot", "Jasdan"],
  sabarkantha: ["Himmatnagar"],
  surat: ["Surat", "Bardoli"],
  surendranagar: ["Surendranagar", "Wadhwan"],
  tapi: ["Vyara"],
  vadodara: ["Vadodara", "Padra"],
  valsad: ["Valsad", "Pardi"],
};

export const ItemsSponsor = {
  isMulti: true,
  options: [
    { value: "coriander", label: "Coriander" },
    { value: "ginger", label: "Ginger" },
    { value: "garlic", label: "Garlic" },
    { value: "ajwain", label: "Ajwain (Carom seeds)" },
    { value: "chillies", label: "Chillies and dried chillies" },
    { value: "fenugreek_seeds", label: "Fenugreek seeds" },
    { value: "fennel", label: "Fennel" },
    { value: "cinnamon_leaves", label: "Cinnamon leaves (Tejpatta / Bay leaves)" },
    { value: "cumin", label: "Cumin" },
    { value: "cloves", label: "Cloves" },
    { value: "cardamom", label: "Cardamom" },
    { value: "mustard", label: "Mustard" },
    { value: "methi", label: "Methi (Fenugreek)" },
    { value: "isabgol", label: "Isabgol (Psyllium husk)" },
    { value: "asafoetida", label: "Asafoetida" },
    { value: "aniseed", label: "Aniseed" },
    { value: "dry_ginger", label: "Dry ginger" },
    { value: "turmeric", label: "Turmeric" },
    { value: "grass_fodder", label: "Grass and Fodder" },
    { value: "timber_wood", label: "Timber/wood preparation" },
    { value: "bamboo", label: "Bamboo" }
  ]
}

